import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { logoutOktaSession, terminateOAGSession } from '../../actions/application'
import { selectLogoutStatusOkta, selectLogoutStatusOAG } from '../../reducers/application'


const mapStateToProps = createStructuredSelector({
    logoutStatusOAG: selectLogoutStatusOAG,
    logoutStatusOkta: selectLogoutStatusOkta
})

const mapDispatchToProps = dispatch => {
    return {
        logoutOktaSession: url => dispatch(logoutOktaSession(url)),
        terminateOAGSession: logoutOAGSession => dispatch(terminateOAGSession(logoutOAGSession))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)
